function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24327"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19509",
    d: "m24.4 10.973-1.7-1.294A6.345 6.345 0 0 0 22.74 9a6.154 6.154 0 0 0-.04-.68l1.7-1.294a.8.8 0 0 0 .2-1.033l-1.766-2.978a.829.829 0 0 0-1.022-.358l-2 .784a6.921 6.921 0 0 0-1.2-.68L18.3.69a.811.811 0 0 0-.818-.69H13.94a.809.809 0 0 0-.815.684l-.306 2.078a7.134 7.134 0 0 0-1.2.68l-2.01-.786a.846.846 0 0 0-1.014.352L6.824 5.989a.792.792 0 0 0 .2 1.039l1.7 1.294a5.78 5.78 0 0 0 0 1.358l-1.7 1.294a.8.8 0 0 0-.2 1.033l1.767 2.977a.828.828 0 0 0 1.022.358l2-.784a6.982 6.982 0 0 0 1.2.68l.3 2.07a.811.811 0 0 0 .827.692h3.543a.81.81 0 0 0 .816-.684l.306-2.077a7.167 7.167 0 0 0 1.2-.681l2.01.786a.847.847 0 0 0 .3.056.817.817 0 0 0 .712-.407L24.605 12a.8.8 0 0 0-.205-1.027zM15.711 12a3 3 0 1 1 3.081-3 3.044 3.044 0 0 1-3.081 3z",
    transform: "translate(-6.711)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.4b1c0f034c9089e094bb476e78c24b30.svg";
export { ForwardRef as ReactComponent };